// extracted by mini-css-extract-plugin
export default {"iconHemsterRevive":"IconHemsterRevive_iconHemsterRevive__TiH4B"};